export default __webpack_public_path__ + "assets/images/bonus.f3a037.avif";